<template>
  <b-row>
    <b-col md="1">
      / <input class="url-input" type="text" v-model="item.name" required />
      <b-link @click="addItem"><i class="fa fa-plus" /></b-link>
      <b-link @click="delItem(item.name)"><i class="fa fa-minus" /></b-link>
    </b-col>
    <b-col v-if="item.child && item.child.length > 0">
      <template v-for="(childItem, index) in item.child">
        <url-structure :key="item.child.length.toString() + index.toString()" :urlItem="childItem" :parent="item" @del="del" />
      </template>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'url-structure',
  props: ['urlItem', 'parent'],
  components: {
    'url-structure': import('./UrlStructure.vue')
  },
  data () {
    return {
      item: this.urlItem
    }
  },
  methods: {
    addItem () {
      this.item.child.push({name: '', child: []})
    },
    delItem (name) {
      this.$emit('del', {name: name, parent: this.parent})
    },
    del (data) {
      for (let idx in data.parent.child) {
        if (data.parent.child[idx].name === data.name) {
          data.parent.child.splice(idx, 1)
          break
        }
      }
    }
  }
}
</script>

<style>
  .url-input {
    width: 90%;
  }
  .col-md-1 {
    padding: 0 !important;
  }
  .row {
    margin-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// UrlStructure.vue?432a9690